import { useTranslation } from "react-i18next";

export default function FormatDate({ timestamp }) {
    const [t] = useTranslation(["global"]);

    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = date.toDateString() === yesterday.toDateString();

    const time = date.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
    });

    let result;
    if (isToday) {
        result = `${t("time.today")} - ${time}`;
    } else if (isYesterday) {
        result = `${t("time.yesterday")} - ${time}`;
    } else {
        result = new Intl.DateTimeFormat('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        }).format(date) + ` - ${time}`;
    }

    return <span>{result}</span>;
}